export type FetchErrorDetails = {
  requestInfo?: RequestInfo;
  requestInit?: RequestInit;
  response?: Response;
  message?: string;
  wrappedError?: unknown;
};
export default class FetchError extends Error {
  public name = 'FetchError';

  public requestInfo?: RequestInfo;
  public requestInit?: RequestInit;
  public response?: Response;
  public wrappedError?: unknown;

  constructor(details?: FetchErrorDetails) {
    super('Error');
    if (details) {
      this.updateDetails(details);
    }
  }

  updateDetails(details: FetchErrorDetails) {
    if (details.requestInfo !== undefined) {
      this.requestInfo = details.requestInfo;
    }

    if (details.requestInit !== undefined) {
      this.requestInit = details.requestInit;
    }

    if (details.response !== undefined) {
      this.response = details.response;
    }

    if (details.message !== undefined) {
      this.message = details.message;
    }

    if (details.wrappedError !== undefined) {
      this.wrappedError = details.wrappedError;
    }
  }
}
